import {
    StanFilterConfig,
    StanFilterOperatorCode,
    StanFilterValue,
} from '@/components/core-components/StanFilters/types';

export function parseQueryFilters(query: URLSearchParams, filters: StanFilterConfig[]): StanFilterValue[] {
    const filteredFields: StanFilterValue[] = [];
    for (const [queryArg, value] of query.entries()) {
        const match = queryArg.match(/^([a-z-]*)\[([a-z-]*)\]$/);
        if (match && match.length === 3) {
            const fieldName = match[1];
            if (!fieldName) continue;
            const operatorCode = match[2] as StanFilterOperatorCode | undefined;
            if (!operatorCode) continue;

            if (!value) continue;

            // Convert numeric strings to numbers for select type filters
            let parsedValue: string | number = value;
            const filter = filters.find(val => val.id === fieldName);
            if (!filter) continue;

            if (filter.type === 'select' && !isNaN(Number(value))) {
                parsedValue = Number(value);
            }

            const filterField: Partial<StanFilterValue> = {
                operator: operatorCode,
                value: parsedValue,
            };

            filteredFields.push({ ...filterField, id: fieldName, type: filter.type } as StanFilterValue);
        }
    }
    const filteredValues: StanFilterValue[] = Object.values(filteredFields);
    return filteredValues;
}

export function removeQueryFilters(query: URLSearchParams, fieldNames: string[]): URLSearchParams {
    const newQueryObject: URLSearchParams = new URLSearchParams();
    for (const queryArg in query) {
        const match = queryArg.match(/^([a-z-]*)\[([a-z-]*)\]$/);
        if (!match) continue;
        const fieldName = match[1];
        if (!fieldName) continue;
        if (!(match.length === 3 && fieldNames.includes(fieldName))) {
            const queryObject = query.get(queryArg);
            if (!queryObject) continue;
            newQueryObject.set(queryArg, queryObject);
        }
    }
    return newQueryObject;
}
